module.exports = __webpack_public_path__ + "static/media/reorg-modeling.68030d0d.jpg";